/**
 * abilityVfxKatarina — Katarina Q/W/E/R silhouettes (SPY-610).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

export function buildBouncingBlade(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1);
  const steel = mat(THREE, spec.color || 0xf87171);
  const glint = mat(THREE, 0xfecaca, 0.85);
  const blade = new THREE.Mesh(new THREE.BoxGeometry(0.5 * s, 0.06 * s, 0.14 * s), steel);
  blade.position.y = 0.42 * s;
  group.add(blade);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.1 * s, 0.22 * s, 4).rotateX(Math.PI / 2), glint);
  tip.position.set(0, 0.42 * s, 0.32 * s);
  group.add(tip);
  group.userData = { shape: 'bouncing_blade' };
  return group;
}

export function buildPreparation(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1.15);
  const dag = mat(THREE, spec.color || 0xef4444, 0.88);
  const spin = new THREE.Mesh(new THREE.TorusGeometry(0.35 * s, 0.05 * s, 8, 16), dag);
  spin.rotation.x = Math.PI / 2;
  spin.position.y = 0.55 * s;
  group.add(spin);
  group.userData = { shape: 'preparation' };
  return group;
}

export function buildShunpo(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1.1);
  const puff = mat(THREE, spec.color || 0xfbbf24, 0.75);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.2 * s, 0.45 * s, 14).rotateX(-Math.PI / 2),
    puff
  );
  ring.position.y = 0.08;
  group.add(ring);
  group.userData = { shape: 'shunpo' };
  return group;
}

export function buildDeathLotus(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.85 * (spec.scale || 1.5);
  const lotus = mat(THREE, spec.color || 0xb91c1c, 0.9);
  for (let i = 0; i < 6; i += 1) {
    const petal = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.55 * s, 4), lotus);
    petal.rotation.y = (Math.PI * 2 * i) / 6;
    petal.position.y = 0.35 * s;
    group.add(petal);
  }
  group.userData = { shape: 'death_lotus' };
  return group;
}
